import './FeatureList.css'

const features = [
  {
    name: 'Long-running Autonomous Agent',
    content: 'Claude Code runs for hours. No babysitting needed. Auto-checkpoint every prompt.',
  },
  {
    name: 'Auto-recovery',
    content: 'Claude Code recovers on its own. No intervention required. Automatic rollback on failure.',
  },
  {
    name: 'Multi-branch Exploration',
    content: "Claude Code tries multiple paths. Don't choose, try both. Git-like branching.",
  },
]

function FeatureCard({ name, content }: { name: string; content: string }) {
  return (
    <div className="feature-list__card">
      <div className="feature-list__tag">{name}</div>
      <p className="feature-list__content">{content}</p>
    </div>
  )
}

export function FeatureList() {
  return (
    <section className="feature-list">
      <div className="feature-list__divider">{'─'.repeat(120)}</div>
      <div className="feature-list__grid">
        {features.map((f) => (
          <FeatureCard key={f.name} name={f.name} content={f.content} />
        ))}
      </div>
    </section>
  )
}
